export default {
    row1: [
        {
            column: "column1",

            rows: {
                row1: [
                    {
                        name: "customeBankDealerEntityName",
                        label: "Entity Name",
                        component: "text-field",
                        Required: true,
                    },
                    {
                        name: "customeBankDealerSetasDefault",
                        label: "Set as Default",
                        component: "checkbox",

                    },

                ],
                row2: [
                    {
                        name: "customeBankDealerBankDrAddress",
                        label: "Bank/Dlr Name And Address",
                        component: "text-field",
                        Required: true,
                    },


                ],
                row3: [
                    {
                        name: "customeBankDealerACNo",
                        label: "A/C No.",
                        component: "text-field",
                    },

                ],
                row4: [
                    {
                        name: "customeBankDealerADCode",
                        label: "AD Code",
                        component: "text-field",
                    },


                ],
            }
        }
    ]
}